/**
 * Created by Rodrigo Quesada on 22/02/17.
 */
import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {noop} from '@angular/core/src/linker/view_utils';

// region NG_VALUE_ACCESSOR
const YES_NO_SELECTOR_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => YesNoSelectorComponent),
    multi: true
};
// endregion

@Component({
    selector: 'my-yes-no-selector',
    template: require('./yes-no-selector.component.html'),
    styles: [require('./yes-no-selector.component.scss')],
    providers: [YES_NO_SELECTOR_CONTROL_VALUE_ACCESSOR],
    host: {
        class: 'yes-no-selector'
    }
})
export class YesNoSelectorComponent implements ControlValueAccessor {

    // region Input
    @Input() name: string|null = null;
    @Input() disabled: boolean = false;
    @Input() errorMessage: string;

    // endregion

    _value?: boolean;

    @Input() get value(): boolean|undefined { return this._value; }

    set value(value: boolean|undefined) {
        if (value !== this._value) {
            this._value = value;
            this._onChangeCallback(value);
        }
    }

    constructor() {
    }

    // region ControlValueAccessor
    /** Callback registered via registerOnTouched (ControlValueAccessor) */
    private _onTouchedCallback: () => void = noop;
    /** Callback registered via registerOnChange (ControlValueAccessor) */
    private _onChangeCallback: (_: any) => void = noop;

    writeValue(value?: boolean): void {
        this._value = value;
    }

    registerOnChange(fn: any): void {
        this._onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouchedCallback = fn;
    }

    // endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/yesno/selector/yes-no-selector.component.ts